/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { TrendRequestBuilderRequestsMetadata, type TrendRequestBuilder } from './trend/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/analytics/sales
 */
export interface SalesRequestBuilder extends BaseRequestBuilder<SalesRequestBuilder> {
    /**
     * The trend property
     */
    get trend(): TrendRequestBuilder;
}
/**
 * Uri template for the request builder.
 */
export const SalesRequestBuilderUriTemplate = "{+baseurl}/api/analytics/sales";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const SalesRequestBuilderNavigationMetadata: Record<Exclude<keyof SalesRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    trend: {
        requestsMetadata: TrendRequestBuilderRequestsMetadata,
    },
};
/* tslint:enable */
/* eslint-enable */
